module.exports = __webpack_public_path__ + "img/logo_white.f19c9051.png";